import { render, staticRenderFns } from "./CrearTarimaModalComponent.vue?vue&type=template&id=655ce648&"
import script from "./CrearTarimaModalComponent.vue?vue&type=script&lang=js&"
export * from "./CrearTarimaModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports